/**
 * Returns true if the given image path is a known placeholder (tst.jpg).
 * Shared across Datacontext, shop, and Wishlist to avoid duplication.
 */
export const isTstPlaceholder = (path) =>
  !path ? true : path.includes("tst.jpg") || path.endsWith("tst.jpg");
